import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classnames from 'classnames';
import { LOADING_CIRCLE, Status } from 'common/utils/constants';
import { deleteStatusNotification } from 'redux/actions';
import SvgAF from 'components/shared/SvgAF/SvgAF';
import { IconLoader } from 'common/IconLoader';
import { getTrimmedText } from './utils';
import './StatusNotifications.css';
import MultiStatusPanel from './MultiStatusPanel/MultiStatusPanel';
import Draggable from 'react-draggable';
import LoadingIndicator from '../LoadingIndicator/LoadingIndicator';

const MAX_NOTIFICATION_TEXT_WIDTH = 200;

const StatusNotifications = () => {
  const [dragIconHovered, setDragIconHovered] = useState(false);
  const dispatch = useDispatch();

  const currentStatusNotification = useSelector((store) => store.ui.sharedPages.statusNotification);
  const trimmedText = getTrimmedText(currentStatusNotification?.text, MAX_NOTIFICATION_TEXT_WIDTH);

  return (
    <div className={'Status_Notification_Globe'}>
      <div className={'Status_Notification_Wrapper'}>
        {currentStatusNotification?.id != null && (
          <Draggable handle=".Status_Notification_Drag">
            <div
              className={classnames('Status_Notification_Item', {
                Status_Notification_Error: currentStatusNotification?.status === Status.FAILURE
              })}
            >
              <div
                className="Status_Notification_Drag"
                draggable={true}
                onDragStart={(event) => event.preventDefault()}
                onMouseEnter={() => {
                  setDragIconHovered(true);
                }}
                onMouseLeave={() => {
                  setDragIconHovered(false);
                }}
              >
                <img
                  src={dragIconHovered ? IconLoader.icon_drag_dots_hover : IconLoader.icon_drag_dots_default}
                  alt={''}
                />
              </div>
              {currentStatusNotification?.mode === 'multi' && <MultiStatusPanel />}
              {currentStatusNotification?.mode !== 'multi' && (
                <div role="status" id="ActiveStatus" className="Status_Notification_Item_Message_Container">
                  {currentStatusNotification?.icon != null && (
                    <img
                      className={classnames({
                        blinkMe: currentStatusNotification?.id === 'blinkOn'
                      })}
                      src={currentStatusNotification?.icon}
                      alt={''}
                    />
                  )}
                  {currentStatusNotification?.status === Status.PENDING && (
                    <div className="Status_Notification_LoadingIcon">{LOADING_CIRCLE}</div>
                  )}
                  {
                    <div className="Status_Notification_Text_Container">
                      <div
                        className="Status_Notification_Text"
                        style={{ fontSize: trimmedText?.length > 150 ? '14px' : '15px' }}
                        data-tip={currentStatusNotification?.text}
                      >
                        {currentStatusNotification.status === Status.PENDING ? (
                          <LoadingIndicator text={trimmedText} />
                        ) : (
                          trimmedText
                        )}
                      </div>
                      {currentStatusNotification.retry && (
                        <div className="Status_Notification_RetryContainer">
                          <button className="Status_Notification_Retry" onClick={currentStatusNotification.retry}>
                            Try again
                          </button>
                        </div>
                      )}
                    </div>
                  }
                </div>
              )}
              {!currentStatusNotification.hideCloseButton && (
                <div className="Status_Notification_Close_Button">
                  <SvgAF
                    img={IconLoader.icon_close_x}
                    hover={IconLoader.icon_close_hover}
                    onClick={() => dispatch(deleteStatusNotification(currentStatusNotification))}
                  />
                </div>
              )}
            </div>
          </Draggable>
        )}
      </div>
    </div>
  );
};

export default StatusNotifications;
